import React from 'react';
import styled, { css } from 'styled-components';
import { mediaQuery } from '../../../../theme';
import { Location } from '../../../../icons/Location';
import { InvertedInput, Input, InputProps } from '../../../input/Input';
import { colors } from '../../../../theme/color';

type Props = {
  showLocation: boolean;
  onLocationClick: () => void;
  type: 'primary' | 'secondary';
};

export const AddressInputField: React.FC<InputProps & Props> = ({
  showLocation,
  onLocationClick,
  ...props
}) => {
  return (
    <ApartmentNumberInputField {...props}>
      {showLocation && (
        <StyledLocation onClick={onLocationClick}>
          <Location />
        </StyledLocation>
      )}
    </ApartmentNumberInputField>
  );
};

export const ApartmentNumberInputField: React.FC<InputProps> = ({ type = 'primary', ...props }) => {
  if (type === 'primary') {
    return <PrimaryAddressInput {...props} />;
  }

  return <SecondaryAddressInput {...props} />;
};

const inputStyles = css`
  max-width: none;

  @media ${mediaQuery.medium} {
    max-width: 45%;
  }
`;

const SecondaryAddressInput = styled(InvertedInput)`
  ${inputStyles}
  label {
    color: ${colors.black};
  }

  input {
    border-color: rgba(0, 0, 0, 0.3);
  }
`;

const PrimaryAddressInput = styled(Input)`
  ${inputStyles}
`;

const StyledLocation = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  width: auto;
  height: 24px;
  margin: 0;
  padding: 0;
  right: 16px;
  top: 18px;
  cursor: pointer;
  color: ${colors.brandPrimary};

  transition: color 0.1s ease-in;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${colors.green.darker(40)};
  }
`;
